"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogosProperty = exports.logosPropertyDefinition = void 0;
exports.logosPropertyDefinition = {
    view: {
        label: 'Logos',
        hint: 'Must have transparent background & make sure all logos are visible both on light (default theme) and dark backgrounds.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'logos',
};
const isLogosProperty = (prop) => {
    return prop.name === exports.logosPropertyDefinition.name;
};
exports.isLogosProperty = isLogosProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nb3MucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9sb2dvcy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxPQUFPO1FBQ2QsSUFBSSxFQUFFLHdIQUF3SDtLQUMvSDtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE9BQU87Q0FDa0IsQ0FBQTtBQUkxQixNQUFNLGVBQWUsR0FBRyxDQUFDLElBQWtCLEVBQXlCLEVBQUU7SUFDM0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLCtCQUF1QixDQUFDLElBQUksQ0FBQTtBQUNuRCxDQUFDLENBQUE7QUFGWSxRQUFBLGVBQWUsbUJBRTNCIn0=